<script>
    import {Tween} from 'svelte/motion';
    import {cubicOut} from 'svelte/easing';

    import I18n from '@js/modules/translations';

    import Computation from '@js/modules/computation';

    import {userStore} from '@js/stores/userStore';
    import {mapStore} from '@js/stores/mapStore';

    const distanceProgress = new Tween(mapStore.currentDistance, {
        duration: 800,
        easing: cubicOut
    });

    $effect(() => {
        distanceProgress.target = $mapStore.currentDistance;
    });
</script>

<div class="map-distance">
    <span class="map-distance-text">
        {I18n.t('js.maps.distance.content')}
    </span>

    <span class="map-distance-value"
          class:map-distance-present={$mapStore.currentDistance}>
        {Computation.formatDistance(distanceProgress.current, {
            unit: $userStore.unit,
            smartUnit: true,
            kUnit: false
        })}
    </span>
</div>
